import { Icon } from '@components/Icon.tsx';
import { IconType } from '@src/IconType.ts';
import { LoadingSpinner } from '@components/LoadingSpinner.tsx';
import { type MouseEvent } from 'react';
import { classNames } from '@utils/classNames.ts';
import { focusStyle } from '@components/input/utils.ts';

export default function EditButton({
  onClick,
  className,
  testId,
  loading,
}: {
  readonly onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  readonly className?: string;
  readonly testId?: string;
  readonly loading?: boolean;
}) {
  if (loading) {
    return <LoadingSpinner className="!h-[20x] !w-[20px]" />;
  }
  return (
    <>
      <button
        className={classNames(
          'flex items-center justify-center h-[20px] w-[20px] p-0.5 rounded bg-gray-100 hover:bg-white',
          focusStyle,
          className,
        )}
        onClick={onClick}
        data-testid={testId}
      >
        <Icon
          type={IconType.Pencil}
          className="h-full w-full"
          aria-hidden="true"
        />
      </button>
    </>
  );
}
